/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:auto;display:flex}kendo-splitter[_ngcontent-%COMP%]{flex:auto;width:100%;height:100%}"];
export { styles as styles };
